import { RouteRecordRaw } from 'vue-router';

const careCheckInRoutes: RouteRecordRaw[] = [
  {
    path: '/provider/care-check-in/:token',
    name: 'provider-care-check-in',
    component: () => import('@/apps/provider/careCheckIn/ProviderCareCheckIn.vue'),
    props: true,
    meta: {
      skipAuth: true,
    },
  },
];

export default careCheckInRoutes;
